import { styled } from '@linaria/react';

export default styled.input`
  background-color: #fff;
  border: 1px solid #1a1a1a;
  border-radius: 5px;
  font-size: 18px;
  line-height: 18px;
  height: 40px;
  padding: 8px 15px;
  width: 100%;

  &:focus {
    background-color: #fff;
  }
`;
